import React from 'react';
import Punchcard from '@splunk/dashboard-visualizations/Punchcard';

export default () => (
    <Punchcard
        options={{
            colorMode: 'categorical',
        }}
        encoding={{
            category: 'primary.category',
            size: 'primary.count',
            x: 'primary.date_hour',
            y: 'primary.date_wday',
        }}
        dataSources={{
            primary: {
                requestParams: { offset: 0, count: 73 },
                data: {
                    fields: [
                        {
                            name: 'date_hour',
                        },
                        {
                            name: 'date_wday',
                        },
                        {
                            name: 'count',
                        },
                        {
                            name: 'category',
                        },
                    ],
                    columns: [
                        [
                            '12',
                            '12',
                            '12',
                            '12',
                            '12',
                            '12',
                            '12',
                            '1',
                            '1',
                            '1',
                            '1',
                            '1',
                            '1',
                            '1',
                            '2',
                            '2',
                            '2',
                            '2',
                            '2',
                            '3',
                            '3',
                            '3',
                            '4',
                            '4',
                            '4',
                            '4',
                            '5',
                            '5',
                            '5',
                            '5',
                            '5',
                            '6',
                            '6',
                            '6',
                            '6',
                            '6',
                            '6',
                            '6',
                            '7',
                            '7',
                            '7',
                            '7',
                            '7',
                            '7',
                            '7',
                            '8',
                            '8',
                            '8',
                            '8',
                            '8',
                            '8',
                            '8',
                            '9',
                            '9',
                            '9',
                            '9',
                            '9',
                            '9',
                            '9',
                            '10',
                            '10',
                            '10',
                            '10',
                            '10',
                            '10',
                            '10',
                            '11',
                            '11',
                            '11',
                            '11',
                            '11',
                            '11',
                            '11',
                        ],
                        [
                            'monday',
                            'tuesday',
                            'wednesday',
                            'thursday',
                            'friday',
                            'saturday',
                            'sunday',
                            'monday',
                            'tuesday',
                            'wednesday',
                            'thursday',
                            'friday',
                            'saturday',
                            'sunday',
                            'monday',
                            'thursday',
                            'friday',
                            'saturday',
                            'sunday',
                            'wednesday',
                            'saturday',
                            'sunday',
                            'tuesday',
                            'wednesday',
                            'thursday',
                            'friday',
                            'monday',
                            'tuesday',
                            'wednesday',
                            'thursday',
                            'friday',
                            'monday',
                            'tuesday',
                            'wednesday',
                            'thursday',
                            'friday',
                            'saturday',
                            'sunday',
                            'monday',
                            'tuesday',
                            'wednesday',
                            'thursday',
                            'friday',
                            'saturday',
                            'sunday',
                            'monday',
                            'tuesday',
                            'wednesday',
                            'thursday',
                            'friday',
                            'saturday',
                            'sunday',
                            'monday',
                            'tuesday',
                            'wednesday',
                            'thursday',
                            'friday',
                            'saturday',
                            'sunday',
                            'monday',
                            'tuesday',
                            'wednesday',
                            'thursday',
                            'friday',
                            'saturday',
                            'sunday',
                            'monday',
                            'tuesday',
                            'wednesday',
                            'thursday',
                            'friday',
                            'saturday',
                            'sunday',
                        ],
                        [
                            3,
                            2,
                            4,
                            1,
                            8,
                            11,
                            16,
                            1,
                            3,
                            2,
                            2,
                            2,
                            11,
                            11,
                            5,
                            2,
                            1,
                            5,
                            8,
                            1,
                            5,
                            1,
                            1,
                            1,
                            1,
                            3,
                            10,
                            10,
                            12,
                            8,
                            10,
                            20,
                            26,
                            28,
                            29,
                            32,
                            6,
                            4,
                            75,
                            65,
                            82,
                            73,
                            66,
                            14,
                            5,
                            130,
                            133,
                            109,
                            119,
                            113,
                            31,
                            12,
                            52,
                            57,
                            64,
                            56,
                            58,
                            47,
                            24,
                            39,
                            18,
                            25,
                            34,
                            39,
                            49,
                            64,
                            36,
                            38,
                            34,
                            30,
                            38,
                            62,
                            70,
                        ],
                        [
                            'Gen Electric GE36',
                            'Gen Electric GE36',
                            'P&Whitney R-4360',
                            'Allison V-1710',
                            'Allison V-1710',
                            'Allison V-1710',
                            'BMW VI',
                            'Gen Electric GE36',
                            'Bristol Mercury',
                            'P&Whitney R-4360',
                            'P&Whitney R-4360',
                            'Bristol Mercury',
                            'Gen Electric GE36',
                            'P&Whitney R-4360',
                            'P&Whitney R-4360',
                            'Bristol Mercury',
                            'Bristol Mercury',
                            'Allison V-1710',
                            'Allison V-1710',
                            'Allison V-1710',
                            'P&Whitney R-4360',
                            'Bristol Mercury',
                            'Allison V-1710',
                            'P&Whitney R-4360',
                            'Bristol Mercury',
                            'Bristol Mercury',
                            'Bristol Mercury',
                            'Allison V-1710',
                            'Allison V-1710',
                            'BMW VI',
                            'Bristol Mercury',
                            'BMW VI',
                            'Gen Electric GE36',
                            'Gen Electric GE36',
                            'BMW VI',
                            'Allison V-1710',
                            'P&Whitney R-4360',
                            'Gen Electric GE36',
                            'P&Whitney R-4360',
                            'Bristol Mercury',
                            'P&Whitney R-4360',
                            'P&Whitney R-4360',
                            'Gen Electric GE36',
                            'BMW VI',
                            'Bristol Mercury',
                            'P&Whitney R-4360',
                            'Bristol Mercury',
                            'Gen Electric GE36',
                            'BMW VI',
                            'P&Whitney R-4360',
                            'Gen Electric GE36',
                            'Gen Electric GE36',
                            'BMW VI',
                            'P&Whitney R-4360',
                            'BMW VI',
                            'Allison V-1710',
                            'Gen Electric GE36',
                            'BMW VI',
                            'Gen Electric GE36',
                            'BMW VI',
                            'Gen Electric GE36',
                            'P&Whitney R-4360',
                            'BMW VI',
                            'Bristol Mercury',
                            'Bristol Mercury',
                            'BMW VI',
                            'Allison V-1710',
                            'Bristol Mercury',
                            'BMW VI',
                            'BMW VI',
                            'Gen Electric GE36',
                            'BMW VI',
                            'P&Whitney R-4360',
                        ],
                    ],
                },
                meta: { totalCount: 100 },
            },
        }}
    />
);
